import React, { useEffect, useState } from "react";
import moment from "jalali-moment";
import DtPicker from "react-calendar-datetime-picker";
import { isEmpty } from "lodash";

import { convertDate } from "../../utils";

import "react-calendar-datetime-picker/dist/index.css";

const CustomDateTimePicker = ({
  className = "form-control-lg form-control",
  onChange = () => {},
  onBlur,
  initValue,
  isDisabled,
  ...props
}) => {
  const [val, setVal] = useState({
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
  });

  const getConvertDate = (value) => {
    if (value)
      return moment(
        `${value.year}-${value.month}-${value.day} ${value.hour}:${value.minute}`,
        "jYYYY-jMM-jDD HH:mm"
      ).toDate();
  };

  useEffect(() => {
    if (!isEmpty(val)) {
      const dateNow = new Date();
      const convertDate = new Date(getConvertDate(val));

      dateNow.setFullYear(dateNow.getFullYear() - 100);

      const isConvertDateBiggerThan = dateNow.getTime() < convertDate.getTime();
      if (isConvertDateBiggerThan) {
        onChange(getConvertDate(val));
        onBlur && onBlur();
      }
    }
  }, [val]);

  useEffect(() => {
    const convertInitValue = new Date(initValue)?.getTime();
    const convertVal = new Date(getConvertDate(val))?.getTime();

    if (initValue && convertInitValue !== convertVal) {
      setVal({
        year: +convertDate(initValue, "YYYY"),
        month: +convertDate(initValue, "MM"),
        day: +convertDate(initValue, "DD"),
        hour: +convertDate(initValue, "HH"),
        minute: +convertDate(initValue, "mm"),
      });
    }
  }, [initValue]);

  const inputClass = `${className} ${
    isDisabled ? "" : "bg-white"
  } text-left h-25`;

  return (
    <>
      <DtPicker
        local="fa"
        inputClass={inputClass}
        headerClass="bg-primary"
        showWeekend={true}
        clearBtnClass="text-danger"
        onChange={setVal}
        initValue={val}
        isDisabled={isDisabled}
        {...props}
      />
    </>
  );
};

export default CustomDateTimePicker;
